import { render, staticRenderFns } from "./IconSpeakerphoneSolid.vue?vue&type=template&id=54a8e0ba"
import script from "./IconSpeakerphoneSolid.vue?vue&type=script&lang=js"
export * from "./IconSpeakerphoneSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports